// Typelizer digest 6e9bdf32207f5cc40469cedfa7114df6
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /admin */
  adminRoot: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/admin', {}, options),
    method: 'get',
  }),

  /** GET / */
  root: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/', {}, options),
    method: 'get',
  }),
}
